import React from 'react';
import { Stack, Typography } from '@mui/material';

import { ListCard } from 'components/Card';

import { DragHandle } from './DragHandle';
import { RowActions } from './RowActions';

export const LevelStructureListItem = ({
  name,
  levels,
  role_count,
  canDrag,
  isDragged,
  dragHandlers,
  openLevels,
  markForEdit,
  markForDelete,
}) => {
  return (
    <ListCard
      p={1.5}
      draggable={canDrag}
      aria-label={`Level structure ${name}`}
      sx={{ opacity: isDragged ? 0.4 : 1, cursor: canDrag ? 'grab' : 'default' }}
      {...(canDrag && dragHandlers)}
    >
      <Stack direction="row" alignItems="center" flex={12} gap={1} minWidth={0} pl={1}>
        {canDrag && <DragHandle />}
        <Typography
          variant="body1"
          fontWeight={700}
          fontSize="1rem"
          noWrap
          role="button"
          sx={{ textDecoration: 'underline', cursor: 'pointer' }}
          onClick={openLevels}
        >
          {name}
        </Typography>
      </Stack>

      <Stack justifyContent="center" minWidth={100} pl={2}>
        <Typography variant="caption" fontWeight={700}>
          Levels
        </Typography>
        <Typography
          variant="body2"
          fontWeight={700}
          role="button"
          aria-label={`Levels of ${name}`}
          sx={{ textDecoration: 'underline', cursor: 'pointer' }}
          onClick={openLevels}
        >
          {levels.length}
        </Typography>
      </Stack>

      <Stack direction="row" alignItems="center" flex={1} position="relative" minWidth={200} pl={2}>
        <Stack>
          <Typography variant="caption" fontWeight={700}>
            Roles
          </Typography>
          <Typography variant="body2" fontWeight={700} aria-label={`Roles of ${name}`}>
            {role_count}
          </Typography>
        </Stack>

        <RowActions name={name} onEdit={markForEdit} onDelete={markForDelete} />
      </Stack>
    </ListCard>
  );
};
